import React, { Component,useContext } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { showLoader } from "../../../redux/actions/action_loader";
import { playIcon, videoPlayerIcon } from "../../../images/images";
import "./VideoConsent.css";
import axios from "axios";
import ConsentInstruction from "../ConsentInstruction/ConsentInstruction";
import ConsentStepperContainer from "../ConsentStepper/ConsentStepperContainer";
import { getDevice, isIOSDevice } from "../../../utils/getDevice";
import ConsentLanguage from "../ConsentLanguage/ConsentLanguage";
import {
    engConsentDeclaration,
    hinConsentDeclaration,
    muteAudio,
    playVoiceOver,
    stopAudio,
} from "../../../utils/handleVoiceAndLang";
import { getApiData } from "../../../api/api";
import { generateCorrelationId } from "../../../utils/correlationId";
import { getCredentials, getHeader, getUploadHeader } from "../../../api/headers";
import { multilang } from "../../../locate/multiLang/multiLang";
import {
    generateVideoThumbnail,
    handleProgress,
    isNewUI,
} from "../../../utils/handleProgress";
import "./VideoConsentNew.css";
import {
    checkBtnIcon,
    consentRecordFrame,
    crossBtnIcon,
    playBtnIcon,
    polygonIcon,
    recordBtnIcon,
    stopRecordIcon,
    voiceAssistanrImg,
    voiceAssistantSvg,
    recordVideoAgainIcon
} from "../../../images/btnIcons";
import VideoConsentInstructions from "../../POSV_New_Ui/VideoConsentInstructions/VideoConsentInstructions";
import VideoConsentLanguageSelection from "../../POSV_New_Ui/VideoConsentLanguageSelection/VideoConsentLanguageSelection";
import DotsLoader from "../../Loader/DotsLoader/DotsLoader";
import VideoSubmission from "../../POSV_New_Ui/VideoSubmission/VideoSubmission";
import handClickAnimation from "../../../images/new_ui_imgs/hand-click-cursor.json";
import lottie from "lottie-web";
import { SpeakerContext } from "../../../context/SpeakerContext";
import { compress, getBase64TypeAndString } from "../../../utils/compressor";
import { getSpeechToTextLanguage } from "../../../utils/handleSpeechToTextLangs";
import { encryptedDataWithECBAlgo, fileToBase64 } from "../../../utils/handleData";
import AxiosRequest from "../../../utils/axios";
import { CAPS_Y } from "../../../utils/constants";

const AXIOS = new AxiosRequest().getClient()

class VideoConsent extends Component {
    mediaRecorder;
    videoVerifyRecorder;
    videoVerifyParts = [];

    scrollInterval;

    isSpeaking = false;
    videoInterval;
    videoParts = [];
    recordingInterval;
    uploadApiTimeInterval;
    time = 0;
    apiTime = 300;
    timeWithoutRecording;
    timing = 0;
    timer;
    recognitionInstance;
    transcriptResult = ""
    state = {
        recordingStarted: false,
        downloading: false,
        startRecordingButtonText: false,
        showRecording: false,
        recordingTime: 0,
        selectLang: true,
        showInstructions: false,
        consentSubmitted: false,
        streamingErr: false,
        enableStartBtn: false,
        loadingCamera: true,
        selectedLang: "",
        streamErrMsg: "",
        apiSource: axios.CancelToken.source(),
        apiTimeoutErr: false,
        authToken: "",
        textInAllLanguages: JSON.parse(
            localStorage.getItem("consentDeclarationText")
        ),
        consentDeclarationText: "",
        audioError: "",
        audioErrInAllLang: multilang,
        volCounting: 0,
        submitting: false,
        mergeErr: false,
        mergeErrMsg: "",
        tokenGenerated: false,
        tokenErr: false,
        submitFailed: false,
        loading: false,
        verifyApiCalled: false,
        thumbnailImg: "",
        displayError: "",
        isNewDeclaration: localStorage.getItem("vPosvNewDeclaration"),
        captureImageArray: [],
        retryMutedRecording :0,
        muteAudioRecorded: false,
        useNewVideoUploadMethod: localStorage.getItem("isVposvS3Upload") === CAPS_Y,
    };
    componentDidMount = async () => {
        const { handleAudioIconDisplay,isVoiceOverDisable } = this.context;
        handleAudioIconDisplay(true);
        const reloadAfterSelfie = sessionStorage.getItem("reloadAfterSelfie")
        if(reloadAfterSelfie === CAPS_Y) {
            sessionStorage.setItem("reloadAfterSelfie", "N")
            window.location.reload()
        }
        // this.getAuthToken()
        handleProgress(80);
        if (isNewUI()) {
            let lng = this.getlanguageName();
            this.handleLanguageSelection(lng);
        }
        console.log("device", getDevice());
        if (isNewUI()) {
            if(isVoiceOverDisable) {
                playVoiceOver("ci-aud", "videoconsent");
                muteAudio("ci-aud");
              }
              else {
                stopAudio("ci-aud");
                playVoiceOver("ci-aud", "videoconsent");
              }
            
        }
    };

    getlanguageName = () => {
        let lang = localStorage.getItem("LanguageSelected");
        if (lang) {
            if (lang == "eng") {
                return "english";
            }
            if (lang == "hin") {
                return "hindi";
            }

            return lang.toLowerCase();
        } else {
            return "";
        }
    };

    speechToText = () => {
        console.log("SPEECH TO TEXT STARTED")
        const { recordingSpeech, isDetectingStopped } = this.state
        let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
        let STTLang = getSpeechToTextLanguage(this.getlanguageName())
        try {
            this.recognitionInstance = new SpeechRecognition();
            this.recognitionInstance.lang = STTLang.code;
            this.recognitionInstance.interimResults = true;
            // recordBtn.classList.add("recording");
            // recordBtn.querySelector("p").innerHTML = "Listening...";
            this.recognitionInstance.start();
            this.recognitionInstance.onresult = (event) => {
                const speechResult = event.results[0][0].transcript;
                //detect when intrim results
                if (event.results[0].isFinal) {
                  if(!isDetectingStopped){
                    this.transcriptResult += " " + speechResult;
                  }
                    this.setState({speechTranscript: this.transcriptResult})
                } else {
                }
            };
            this.recognitionInstance.onspeechend = () => {
                this.speechToText();
            };
            this.recognitionInstance.onerror = (event) => {
                this.stopSTTRecording();
                if (event.error === "no-speech") {
                    console.log("No speech was detected. Stopping...");
                } else if (event.error === "audio-capture") {
                    console.log(
                        "No microphone was found. Ensure that a microphone is installed."
                    );
                } else if (event.error === "not-allowed") {
                    console.log("Permission to use microphone is blocked.");
                } else if (event.error === "aborted") {
                    console.log("Listening Stopped.");
                } else {
                    console.log("Error occurred in recognition: " + event.error);
                }
            };
        } catch (error) {
            this.setState({ recordingSpeech : false})
    
            console.log(error);
        }
    }
    
     startListening = () => {
        const { recordingSpeech } = this.state
        if (!recordingSpeech) {
            this.speechToText();
            this.setState({ recordingSpeech : true});
        } else {
            this.stopSTTRecording();
        }
    }
    
     stopSTTRecording = () => {
        if (this.recognitionInstance) {
          console.log("Recognition Stopped")
            this.recognitionInstance.stop();
        }
        this.setState({ recordingSpeech : false, isDetectingStopped: true});
    }

    componentWillUnmount = () => {
        this.stopCamera();
        clearInterval(this.uploadApiTimeInterval);
    };

    stopCamera = () => {
        const video = document.getElementById("video-consent");
        if (video && video.srcObject) {
            console.log(video.srcObject.getVideoTracks());
            video.pause();
            video.srcObject.getVideoTracks()[0].stop();
            video.srcObject.getAudioTracks()[0].stop();
        }
    };

    startVideo = () => {
        let videoWidth = 240;
        let videoHeight = 240;
        if (isIOSDevice()) {
            videoWidth = 150;
            videoHeight = 150;
        }
        if (navigator?.platform == "MacIntel") {
            videoWidth = 150;
            videoHeight = 150;
            console.log("isMac : ", navigator?.platform == "MacIntel");
        }
        let constraintObj = {
            audio: true,
            video: {
                facingMode: "user",
                width: videoWidth,
                height: videoHeight,
            },
        };
        console.log("Is iOS : ", isIOSDevice(), constraintObj);

        const video = document.getElementById("video-consent");
        video.style.visibility = "visible";
        video.style.display = "block";
        video.style.width = "290px";
        video.style.height = "290px";
        video.setAttribute("autoplay", "");
        video.setAttribute("muted", "");
        video.setAttribute("playsinline", "");

        navigator.mediaDevices
            .getUserMedia(constraintObj)
            .then((stream) => {
                video.srcObject = stream;
                const opts = {
                    mimeType: "video/webm;codecs=vp8"
                }
                const recorderOpts = MediaRecorder.isTypeSupported(opts.mimeType) ? opts : {}
                this.mediaRecorder = new MediaRecorder(stream, recorderOpts);
                this.videoVerifyRecorder = new MediaRecorder(stream, recorderOpts);
                this.setState({ enableStartBtn: true, loadingCamera: false });
            })
            .catch((err) => {
                console.log(err.name, err.message);
                let errMessage = "Unable to start Video";
                if (err.name == "NotReadableError") {
                    errMessage = "Unable to get Audio/Video stream";
                }
                if (err.name == "NotAllowedError") {
                    errMessage =
                        "Permission Denied! Please grant permission for accessing Mic and Camera";
                }
                this.setState({
                    streamingErr: true,
                    streamErrMsg: errMessage,
                    enableStartBtn: false,
                    loadingCamera: false,
                });
            });
    };

    verifyVideo = async (vparts) => {
        this.setState({ verifyApiCalled: true });
        let blob = new Blob(vparts, { type: "video/mp4;" });
        let base64Video = await this.blobToBase64(blob);
        const { videoInFileFormat } = base64Video;
        const fileName = `${localStorage.getItem("posvRefNumber")}-verifyVideo.mp4`;
        const identifier = Math.random().toString(36).slice(-6) + "test";

        const { authToken, retryMutedRecording, useNewVideoUploadMethod } = this.state;
        let formData = new FormData();
        formData.append("flowIdentifier", identifier);
        formData.append("flowFilename", fileName);
        formData.append("file", videoInFileFormat);
        formData.append("retryCount", retryMutedRecording);
        formData.append("sourceChannel", localStorage.getItem("sourceChannel"));
        const { url } = getApiData("verifyVideo");
        if(useNewVideoUploadMethod) return

        try {
            const response = await axios.post(url, formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response?.data?.response?.msgInfo?.msgCode == 200) {
              // this.setState({ verifyApiCalled : true })
              if(!response?.data?.response?.payload?.hasAudio && retryMutedRecording < 2 && isNewUI()){
                this.setState({ muteAudioRecorded: true })
                this.stopRecording()
              }
      
            }
            console.log("VERIFY VIDEO RESPONSE : ", response);
        } catch (err) {
            console.log("Err : ", err);
            // return err
        }
    };

    startRecording = () => {
        clearInterval(this.timer);
        clearInterval(this.timeWithoutRecording);
        this.getAuthToken();
        if (this.state.useNewVideoUploadMethod) {
            this.getPresignedUrl();
        }
        this.startListening()
        if(isNewUI()){
            setTimeout(()=>{
              this.setState({ isScrolling : true })
              this.startAutoScroll()
            },500)
          }  
        stopAudio("ci-aud");
        this.setState({
            recordingStarted: true,
            volCounting: 0,
            downloading: false,
            startRecordingButtonText: true,
            displayError: "",
            recordingTime: 0,
        }, () => {
            if (isNewUI()) {
                const autoscrollOverlayDiv = document.querySelector('.ovrly-blurred-bg');
                if (autoscrollOverlayDiv) {
                    autoscrollOverlayDiv.style.zIndex = 2;
                }
            }
        });
        // this.microPhoneAccess();
        this.videoVerifyRecorder.start();
        this.mediaRecorder.start();
        this.recordingInterval = setInterval(async () => {
            this.time++;
            this.setState({ recordingTime: this.time });
            if (this.time == 5) {
                this.videoVerifyRecorder.stop();
                const thumbnailImg = this.captureImage()
                this.setState({ thumbnailImg })
            }
            if (this.time == 80) {
                this.stopRecording();
            }
        }, 1000);
        this.videoVerifyRecorder.ondataavailable = (ev) => {
            const { tokenGenerated } = this.state;
            this.videoVerifyParts.push(ev.data);
            if (tokenGenerated) {
                this.verifyVideo(this.videoVerifyParts);
            }
        };
        this.mediaRecorder.ondataavailable = async (ev) => {
            console.log("DATA AVAILABLE on MEDIA RECORDER :: ", ev)
            this.videoParts.push(ev.data);
        };
        this.mediaRecorder.onerror = (mediaErr) => {
            console.log("mediaRecorder err :: ", mediaErr)
        }
        this.captureImages();
    };

    captureImage = () => {
        // const { vidHeight, vidWidth } = this.state;
        const videoEl = document.getElementById("video-consent");
        const canvasEl = document.createElement("canvas");
        canvasEl.width = videoEl.width;
        canvasEl.height = videoEl.height;
        // canvasEl.width = videoEl.width
        // canvasEl.height = videoEl.height
        canvasEl.getContext("2d").drawImage(videoEl, 0, 0, videoEl.width, videoEl.height);
        let image = canvasEl.toDataURL("image/jpeg", 1.0);
        return image;
      };

    stopRecording = async () => {
        console.log("REC____STOPPED")
        clearInterval(this.timer);
        clearInterval(this.scrollInterval)
        this.stopSTTRecording()
        this.mediaRecorder.stop();
        clearInterval(this.recordingInterval);
        this.time = 0;
        const element = document.getElementById('scrollable-consent-text')
        const vidPlayer = document.getElementById('video-player');
        if (vidPlayer) {
            vidPlayer.style.visibility = 'hidden';
        }
        if (this.isRecodingStartedForNewDec()) {
            const autoscrollOverlayDiv = document.querySelector('.ovrly-blurred-bg');
            if (autoscrollOverlayDiv) {
                autoscrollOverlayDiv.style.zIndex = 1;
            }
        }
        if (isNewUI() && element) {
            element.scrollTo(0,0)
        }
        const video = document.getElementById("video-consent");
        video.style.visibility = "hidden";
        video.style.zIndex = "-1";
        handleProgress(85);
        const { handlebackBtnDisplay } = this.context;
        handlebackBtnDisplay(false);
        this.setState({ recordingStop: true });
    };

    downloadRecordedVideo = async () => {
        this.setState({ downloading: true });
        let blob = new Blob(this.videoParts, { type: "video/mp4;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "recording.mp4";
        a.click();
        let base64Video = await this.blobToBase64(blob);
        console.log(base64Video);
        this.setState({ downloading: false });
        this.videoParts = [];
    };

    blobToBase64 = (blobFile) => {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.readAsDataURL(blobFile);
            reader.onloadend = () => {
                let base64data = reader.result;
                let videoInFileFormat = this.dataURLtoFile(
                    base64data,
                    "My_recording.mp4"
                );
                this.setState({ videoRecordingFile: videoInFileFormat });
                resolve({ base64data, videoInFileFormat });
            };
        });
    };

    dataURLtoFile = (dataurl, filename) => {
        let arr = dataurl.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };

    recordAgain = () => {
        const { muteAudioRecorded, retryMutedRecording } = this.state
        if(muteAudioRecorded){
          this.setState({ retryMutedRecording: retryMutedRecording + 1 })
        }
        this.setState({
            recordingStarted: true,
            tokenErr: false,
            submitFailed: false,
            isDetectingStopped: false,
            muteAudioRecorded: false
        });
        this.transcriptResult = ""
        this.time = 0;
        this.videoParts = [];
        const video = document.getElementById("video-consent");
        video.style.visibility = "visible";
        video.style.zIndex = "1";
        handleProgress(80);
        this.setState({
            startRecordingButtonText: true,
            recordingStarted: false,
            recordingStop: false,
            retryErr: false,
            retryMsg: "",
            apiTimeoutErr: false,
            showRecording: false,
            recordingTime: 0,
        });
    };

    playRecording = () => {
        this.setState({ showRecording: true });
        let blob = new Blob(this.videoParts, { type: "video/mp4;" });
        const url = URL.createObjectURL(blob);
        const videoPlayer = document.getElementById("video-player");
        videoPlayer.style.visibility = 'visible'
        videoPlayer.src = url;
        videoPlayer.play();
    };

    submitVideoConsent = async () => {
        const { presignedurl, useNewVideoUploadMethod } = this.state
        const videoPlayer = document.getElementById("video-player");
        if(videoPlayer) {
            videoPlayer.pause()
        }
        if(!useNewVideoUploadMethod) {
            this.uploadApiTimeInterval = setInterval(() => {
                this.apiTime--;
                if (this.apiTime === 0) {
                    console.log("UPLOAD API TIME OUT");
                    const { apiSource } = this.state;
                    apiSource.cancel("Request Cancelled");
                    clearInterval(this.uploadApiTimeInterval);
                    this.props.showLoader(false);
                    this.setState({ loading: false });
                    this.setState({ apiTimeoutErr: true, submitting: false });
                    return;
                }
            }, 1000);
        }
        this.props.showLoader(true);
        this.setState({ loading: true });
        this.setState({
            requestStartTime: Date.now(),
            apiTimeoutErr: false,
            retryErr: false,
            retryMsg: "",
            submitting: true,
            mergeErr: false,
            mergeErrMsg: "",
        });
        let blob = new Blob(this.videoParts, { type: "video/mp4;" });
        let base64Video = await this.blobToBase64(blob);
        const { videoInFileFormat } = base64Video;
        if (useNewVideoUploadMethod) {
            this.saveImageSnapShots();
            this.uploadVideoThruUrl(presignedurl, videoInFileFormat, 0)
        } else {
            const fileChunks = await this.createFileChunks(videoInFileFormat, 1024 * 500);
            let totalChunks = fileChunks.length;
            let chunksUploaded = 0;
            if (fileChunks.length) {
                this.uploadChunks(totalChunks, fileChunks, chunksUploaded, 0);
            }
        }
    };

    getPresignedUrl = () => {
        return new Promise(async (resolve, reject) => {
            try {
                const { url, body } = getApiData("getPresignedUrl")
                const lposvInsurer = localStorage.getItem("journeyBy") === "I" ? "Y" : "N";
                body.request.payload.posvRefNumber = localStorage.getItem("posvRefNumber");
                body.request.payload.urlType = "VPOSV";
                body.request.payload.extension = "mp4"
                body.request.payload.lposvInsurer = lposvInsurer;
                const response = await AXIOS.post(url, body)
                console.log({ response })
                this.setState({ presignedurl: response?.data?.response?.payload?.s3PresignedUrl })
                resolve({ presignedurl: response?.data?.response?.payload?.s3PresignedUrl })
            } catch (error) {
                console.log({ error })
                reject({ getS3UrlErr: error})
            }
        })
    }

    uploadVideoThruUrl = async (presignedUrl, videoFile, retryCount) => {
        this.setState({ loading: true })
        try {
            const uploadStatus = await fetch(presignedUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "video/mp4" || "application/octet-stream",
                },
                body: videoFile,
            });
            console.log({ uploadStatus })
            if (uploadStatus.status === 200) {
                this.stopCamera()
                this.setState({ consentSubmitted: true, loading: false })
            } else if(uploadStatus.status === 403 && retryCount <= 3) {
                retryCount++
                const resp = await this.getPresignedUrl();
                console.log({ resp: resp.presignedurl, respFULL: resp })
                this.uploadVideoThruUrl(resp.presignedurl, videoFile, retryCount)
            } else {
                this.setState({
                    retryErr: true,
                    retryMsg: "Upload Failed. Please record again.",
                    submitFailed: true,
                    submitting: false,
                    loading: false
                });
            }
        } catch (error) {
            this.setState({
                retryErr: true,
                retryMsg: "Something went wrong! Please record again.",
                submitFailed: true,
                submitting: false,
                loading: false
            });
        } finally {
            this.setState({ submitting: false, loading: false })
        }
    }

    

    captureImages = () => {
      let video = document.getElementById("video-consent");
      let canvas = document.createElement("canvas");
      if (canvas) {
        canvas.width = 240;
        canvas.height = 240;
      } else {
        console.log("canva element not found");
      }
  
      let imageType = "";
      let imageArr = [];
  
      let videoConsentSnapshotInterval = setInterval(async () => {
        if (imageArr.length == 5) {
          clearInterval(videoConsentSnapshotInterval);
          this.setState({ captureImageArray: imageArr, imageType });
          return;
        }
        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        canvas
          .getContext("2d")
          .drawImage(video, 0, 0, canvas.width, canvas.height);
        let image = canvas.toDataURL("image/jpeg", 1.0);
        await compress(image)
          .then(async (res) => {
            let { byteArray } = res;
            let { type, imgString } = getBase64TypeAndString(byteArray);
  
            imageArr.push(imgString);
            imageType = type;
          })
          .catch((err) => {
            console.log("error", err);
          });
      }, 400);
    };
  
  saveImageSnapShots =async()=>{
      const { captureImageArray, imageType } = this.state
      let { url, body } = getApiData("validateCustomerSelfie");
      body.request.header.correlationId = generateCorrelationId();
      body.request.payload.planCode = localStorage.getItem("planCode");
      body.request.payload.posvRefNumber =
        localStorage.getItem("posvRefNumber");
      body.request.payload.multipleImageFile = [...captureImageArray];
      body.request.payload.eventType = "videoSnaps";
  
      body.request.payload.fileExtension = imageType;
      body.request.payload.iosStatus = isIOSDevice() ? true : false;
      body.request.payload.faceDetected = true;
      body.request.payload.journeyBy = localStorage.getItem("journeyBy");
      console.log("req body img arr : ", body)
      try {
          const response = await AXIOS.post(url,body)
          console.log("Save snaps response : ", response)   
      } catch (error) {
          console.log("Save snap error resp : ", error)
      }
    }

    uploadChunks = async (
        totalChunks,
        fileChunks,
        chunksUploaded,
        retryCount
    ) => {
        console.log("Retry Count : ", retryCount);
        let promises = [];
        let chunks = [];
        let noOfChunksUploaded = chunksUploaded;
        let allChunks = fileChunks;
        if (retryCount <= 3) {
            if (totalChunks != chunksUploaded) {
                for (let i = 0; i < allChunks.length; i++) {
                    let formData = new FormData();
                    // const formData = {};
                    for (let key in allChunks[i]) {
                        formData.append(key, allChunks[i][key]);
                        // formData[key] = allChunks[i][key]
                    }
                    if (retryCount > 0) {
                        formData.append("retryNumber", retryCount);
                        // formData["retryNumber"] = retryCount
                    }
                    let promise = this.sendChunkToServer(formData);
                    promises.push(promise);
                }

                let result = await Promise.all(promises);
                console.log("ALL RESULTS : ", result);
                result.forEach((r, index) => {
                    console.log("Result : ", r);
                    // if (r?.message === 'Request Cancelled') {
                    //     return
                    // }
                    if (r?.data?.response?.msgInfo?.msgCode == 200) {
                        noOfChunksUploaded++;
                    } else {
                        if (r?.data?.response?.payload?.chunkNumber) {
                            console.log("CHECKING CHUNK BY CHUNK_NUMBER");
                            let failedChunk = allChunks.filter(
                                (chunk) =>
                                    chunk.flowChunkNumber ==
                                    r?.data?.response?.payload?.chunkNumber
                            );
                            chunks.push(failedChunk[0]);
                            console.log("failedChunk : ", failedChunk);
                        } else {
                            console.log("CHECKING CHUNK BY INDEX");
                            let chunkByIndex = allChunks[index];
                            chunks.push(chunkByIndex);
                        }
                    }
                });
                console.log("FAILED CHUNKS : ", chunks);
                if (noOfChunksUploaded !== totalChunks) {
                    console.log("RETRYING....");
                    if (!chunks.length) {
                        console.log("Didn't find chunks !");
                        clearInterval(this.uploadApiTimeInterval);
                        this.props.showLoader(false);
                        this.setState({ loading: false });
                        this.setState({
                            retryErr: true,
                            retryMsg: "Something went wrong !",
                            submitFailed: true,
                            submitting: false,
                        });
                        return;
                    }
                    retryCount++;
                    this.uploadChunks(
                        totalChunks,
                        chunks,
                        noOfChunksUploaded,
                        retryCount
                    );
                } else {
                    clearInterval(this.uploadApiTimeInterval);
                    const { url } = getApiData("mergeChunk");
                    const { requestStartTime, fileName, identifier, authToken, consentDeclarationText, speechTranscript } =
                        this.state;
                    const lposvInsurer = localStorage.getItem("journeyBy") === "I" ? "Y" : "N"; 
                    const body = {
                        flowIdentifier: identifier,
                        flowFilename: fileName,
                        videoConsentText: (consentDeclarationText),
                        videoConsentSpeech: (speechTranscript?.trim()),
                        lposvInsurer
                    };
                    this.saveImageSnapShots()
                    try {
                        // const response = await axios.post(url, body, {
                        const response = axios.post(url, body, {
                            headers: {
                                Authorization: `Bearer ${authToken}`,
                            },
                        });
                        console.log("Merge Response : ", response);
                        // if (response.data.response.msgInfo.msgCode === "200") {
                        //     console.log("Merge Response : ", response);
                            this.stopCamera();
                            this.setState({ consentSubmitted: true });
                        // } else {
                        //     console.log("Merge ERR : ", response);
                        //     this.setState({
                        //         mergeErr: true,
                        //         mergeErrMsg: response.data.response.msgInfo.msgDescription,
                        //     });
                        // }
                    } catch (err) {
                        console.log("Merge Response Err: ", err);
                        this.setState({
                            mergeErr: true,
                            mergeErrMsg: "Something went wrong ! (merge)",
                        });
                    } finally {
                        let requestEndTime = Date.now();
                        const timeTakenToUpload = `${(requestEndTime - requestStartTime) / 1000
                            } sec`;
                        console.log("Time Taken To Upload : ", timeTakenToUpload);
                        console.log(totalChunks, fileChunks, noOfChunksUploaded);
                        this.props.showLoader(false);
                        this.setState({ loading: false });
                        this.setState({
                            consentSubmitted: true,
                            timeTaken: timeTakenToUpload,
                            submitting: false,
                        });
                    }
                }
            }
        } else {
            console.log("Retry Exhausted : ", retryCount);
            this.props.showLoader(false);
            this.setState({ loading: false });
            this.setState({
                retryErr: true,
                retryMsg: "Upload Failed. Please record again.",
                submitFailed: true,
                submitting: false,
            });
        }
    };

    sendChunkToServer = async (formData) => {
        // let url = "http://localhost:8080/api/uploadFile/v2"
        // let url = "https://ojoo7tbmi5.execute-api.ap-south-1.amazonaws.com/uat/upload"
        // let url = "http://3.111.171.114:8080/api/uploadFile/v1"
        // let url = "http://3.111.171.114:8080/api/uploadFile/v2" // parallel upload
        // let url = "https://ojoo7tbmi5.execute-api.ap-south-1.amazonaws.com/uat/uploadv2"
        const { url } = getApiData("uploadChunk");
        const { apiSource, authToken } = this.state;
        try {
            const response = await axios.post(url, formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Authorization: `Bearer ${authToken}`,
                },
                cancelToken: apiSource.token,
            });

            const { submitConsentAfterPosv, validateOtpForTbLink, checkBackflow } = response.data;
            localStorage.setItem("submitConsentAfterPosv", submitConsentAfterPosv);
            localStorage.setItem("validateOtpForTbLink", validateOtpForTbLink);
            localStorage.setItem("checkBackflow", checkBackflow);

            return response;
        } catch (err) {
            console.log("Err : ", err);
            return err;
        }
    };

    createFileChunks = async (file, cSize) => {
        console.log(file);
        let chunkCounter = 1;
        let startPointer = 0;
        let endPointer = file.size;
        let totalChunks = Math.ceil(endPointer / cSize);
        let oneMegaBytes = 1024 * 1024;
        const fileName = `${localStorage.getItem("posvRefNumber")}.mp4`;
        const identifier = Math.random().toString(36).slice(-6) + "test";
        let fileSizeForDisplay = file.size / oneMegaBytes;
        console.log(
            "SIze : ",
            fileSizeForDisplay.toFixed(3) > 1
                ? `${fileSizeForDisplay.toFixed(3)} mb`
                : `${(fileSizeForDisplay * 1024).toFixed(3)} kb`
        );
        this.setState({
            fileName,
            identifier,
            fileSize:
                fileSizeForDisplay.toFixed(3) > 1
                    ? `${fileSizeForDisplay.toFixed(3)} mb`
                    : `${(fileSizeForDisplay * 1024).toFixed(3)} kb`,
        });
        let chunks = [];
        while (startPointer < endPointer) {
            let chunkInfo = {};
            let newStartPointer = startPointer + cSize;
            let chunk = file.slice(startPointer, newStartPointer);
            startPointer = newStartPointer;
            chunkInfo.flowTotalChunks = totalChunks;
            chunkInfo.flowChunkSize = cSize;
            chunkInfo.flowCurrentChunkSize = chunk.size;
            chunkInfo.flowTotalSize = file.size;
            chunkInfo.flowChunkNumber = this.generateChunkNumber(chunkCounter);
            chunkInfo.flowFilename = fileName;
            chunkInfo.file = await fileToBase64(chunk);
            chunkInfo.flowIdentifier = identifier;
            chunks.push(chunkInfo);
            chunkCounter++;
        }
        return chunks;
    };

    generateChunkNumber = (chunkNum) => {
        if (chunkNum < 10) {
            return `00${chunkNum}`;
        }
        if (chunkNum > 9 && chunkNum < 100) {
            return `0${chunkNum}`;
        }

        return chunkNum;
    };

    getFormattedTime = (sec) => {
        let min = Math.floor(sec / 60);
        let second = sec % 60;
        return `${min < 10 ? "0" + min : min}:${second < 10 ? "0" + second : second
            }`;
    };

    hideConsentInstructions = () => {
        const { isVoiceOverDisable, handlebackBtnDisplay } = this.context;

        handlebackBtnDisplay(true);

        stopAudio("ci-aud");
        if (isVoiceOverDisable) {
            playVoiceOver("ci-aud", "startrecord");
            muteAudio("ci-aud");
        }
        else {
            playVoiceOver("ci-aud", "startrecord");
        }
        
        // if (!isVoiceOverDisable) {
        //     stopAudio('ci-aud')
        //     playVoiceOver('ci-aud', 'startrecord')
        // }
        this.setState({ showInstructions: false });
        this.startVideo()
        this.timeWithoutRecording = setInterval(() => {
            const { recordingStarted } = this.state;
            if (!recordingStarted) {
                console.log("recordingStarted", recordingStarted);
                this.setState({ volCounting: 0 });
                this.timing++;
                if (this.timing == 5) {
                    console.log("err");
                    this.setState({
                        displayError: "Click on the record button to start recording",
                    });
                    let instance = lottie.loadAnimation({
                        container: document.querySelector("#hand-animaton-el"),
                        animationData: handClickAnimation,
                    });
                    clearInterval(this.timer);
                }
            }
        }, 1000);
        // this.microPhoneAccess();
    };

    handleContinueBtn = () => {
        const video = document.getElementById("video-consent");
        if (video && video.srcObject) {
            console.log(video.srcObject.getVideoTracks());
            video.pause();
            video.srcObject.getVideoTracks()[0].stop();
        }
        if (localStorage.getItem("channelName").toLowerCase() === "x") {
            this.props.history.push("/declaration");
        } else {
            this.props.history.push("/generate_otp");
        }
    };

    handleLanguageSelection = (lang) => {
        stopAudio("ci-aud");
        let consentLang = lang.toLowerCase() === "odiya" ? "oriya" : lang;
        const { textInAllLanguages, audioErrInAllLang } = this.state;
        let selectedConsentText = textInAllLanguages[consentLang];
        let selectedAudioText = audioErrInAllLang[consentLang];
        this.setState({
            selectedLang: lang,
            selectLang: false,
            showInstructions: true,
            consentDeclarationText: selectedConsentText,
            audioError: selectedAudioText,
        });
    };

    getAuthToken = async () => {
        this.setState({ tokenErr: false, tokenGenerated: false });
        const { verifyApiCalled } = this.state;
        const { url, body } = getApiData("getToken");
        const { clientId, clientSecret } = getCredentials();
        body.request.header.correlationId = generateCorrelationId();
        body.request.payload.clientId = clientId;
        body.request.payload.clientSecret = clientSecret;
        let xApiKey = getUploadHeader();
        try {
            const response = await axios.post(url, body, {
                headers: {
                    "x-api-key": xApiKey,
                },
            });
            console.log("GET TOKEN Response : ", response);
            if (response?.data?.response?.payload?.accessToken) {
                sessionStorage.setItem('mt',response?.data?.response?.payload?.accessToken)
                if (!verifyApiCalled && this.time > 4) {
                    this.verifyVideo(this.videoVerifyParts);
                }
                this.setState({
                    authToken: response.data.response.payload.accessToken,
                    tokenGenerated: true,
                });
            } else {
                this.setState({ tokenErr: true, tokenGenerated: false, authToken: '' });
                this.stopRecording();
            }
        } catch (err) {
            console.log("GET TOKEN ERR", err);
            this.setState({ tokenErr: true, tokenGenerated: false, authToken: '' });
            this.stopRecording();
        }
    };

    getVolLimit = () => {
        if (getDevice() == "mobile") {
            return 15;
        } else {
            return 50;
        }
    };

    microPhoneAccess = async () => {
        let volumeCallback = null;
        let volumeInterval = null;
        // const volumeVisualizer = document.getElementById('volume-visualizer');
        // Initialize
        try {
            const audioStream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                },
            });
            const audioContext = new AudioContext();
            const audioSource = audioContext.createMediaStreamSource(audioStream);
            const analyser = audioContext.createAnalyser();
            analyser.fftSize = 512;
            analyser.minDecibels = -127;
            analyser.maxDecibels = 0;
            analyser.smoothingTimeConstant = 0.4;
            audioSource.connect(analyser);
            const volumes = new Uint8Array(analyser.frequencyBinCount);
            let currentAvgVal = null;
            volumeCallback = () => {
                analyser.getByteFrequencyData(volumes);
                let volumeSum = 0;
                for (const volume of volumes) {
                    volumeSum += volume;
                }
                const averageVolume = volumeSum / volumes.length;
                // console.log(averageVolume)
                currentAvgVal = averageVolume;

                // Value range: 127 = analyser.maxDecibels - analyser.minDecibels;
                // volumeVisualizer.style.setProperty('--volume', (averageVolume * 100 / 127) + '%');
            };
            let volCount = 0;
            console.log("this.isSpeaking", this.isSpeaking);

            this.timer = setInterval(() => {
                const { recordingStarted, volCounting } = this.state;
                if (this.time < 15) {
                    if (recordingStarted) {
                        console.log("recordingStarted", recordingStarted);
                        console.log("volCounting", volCount);
                        console.log("c", currentAvgVal);
                        if (currentAvgVal < this.getVolLimit()) {
                            console.log("c", currentAvgVal);
                            this.isSpeaking = false;
                            volCount++;
                            console.log("checking sound", currentAvgVal, volCount);

                            if (volCount > 4) {
                                clearInterval(this.recordingInterval);
                                this.setState({
                                    volCounting: volCount,
                                    audioError: "Read the content aloud",
                                    displayError: "",
                                });
                                let instance = lottie.loadAnimation({
                                    container: document.querySelector("#hand-animaton-el"),
                                    animationData: handClickAnimation,
                                });
                                if (isNewUI()) {
                                    playVoiceOver("ci-aud", "readcontentaloud");
                                }
                                console.log(volCounting);
                                this.stopRecording();
                                this.recordAgain();
                                clearInterval(volumeInterval);
                                volumeInterval = null;
                                clearInterval(this.timer);
                            }
                        } else {
                            this.isSpeaking = true;
                            this.setState({ volCounting: 0 });
                            volCount = 0;
                        }
                    } else {
                        console.log(recordingStarted);
                        if (currentAvgVal > this.getVolLimit()) {
                            console.log("c", currentAvgVal);
                            this.isSpeaking = true;
                            console.log("this.isSpeaking", this.isSpeaking);
                            volCount++;
                            console.log("checking sound", currentAvgVal, volCount);

                            if (volCount > 4) {
                                this.setState({
                                    volCounting: volCount,
                                    displayError: "please Click on Start Recording Button ",
                                    audioError: "",
                                });
                                console.log(volCounting);
                                clearInterval(this.recordingInterval);
                            }
                        } else {
                            this.isSpeaking = false;
                            this.setState({ volCounting: 0 });
                            volCount = 0;
                        }
                    }
                } else {
                    volCount = 0;
                    this.setState({ volCounting: 0 });
                    // clearInterval(this.recordingInterval)
                    clearInterval(this.timer);
                    clearInterval(volumeInterval);
                    volumeInterval = null;
                }
            }, 1000);
        } catch (e) {
            console.error(
                "Failed to initialize volume visualizer, simulating instead...",
                e
            );
            let lastVolume = 0;
            volumeCallback = () => {
                const volume = Math.min(
                    Math.max(Math.random() * 100, 0.8 * lastVolume),
                    1.2 * lastVolume
                );
                lastVolume = volume;
                // volumeVisualizer.style.setProperty('--volume', volume + '%');
            };
        }
        if (volumeCallback !== null && volumeInterval === null)
            volumeInterval = setInterval(volumeCallback, 100);
    };

    redirectToPage = (path) => {
        this.props.history.push(path);
    };

    getDeclarationTextClass = () => {
      const { isNewDeclaration, selectedLang, recordingStarted } = this.state
      let smallFontSizeClass = selectedLang == 'manipuri' || selectedLang == 'malayalam' || selectedLang == 'tamil'
      if (selectedLang == 'manipuri') {
          if (isNewDeclaration == "Y") {
              return `manipuri-font declr-txt new-declaration ${isIOSDevice()?'ios-dec-scroll-box':""} ${recordingStarted?'ovrly-dec-ui':''}`
          } else {
              return 'manipuri-font declr-txt'
          }
      } else {
          if (isNewDeclaration == "Y") {
              return `declr-txt new-declaration ${isIOSDevice()?'ios-dec-scroll-box':""} ${recordingStarted?'ovrly-dec-ui':''}`
          } else {
              return 'declr-txt'
          }
      }
  }
  startAutoScroll = () =>{
    const element = document.getElementById('scrollable-consent-text')
    // element.style.padding = "0 20px !important"
    let currentPosition = 0
    // let moveTextPerScroll = element.scrollHeight/100
    let minHeight =140
    // element.scrollTo(0,element.scrollHeight)
     this.scrollInterval = setInterval(()=>{
      const {isScrolling} = this.state
      if(currentPosition>=(element.scrollHeight+minHeight)){
        // stop auto scrolling
        // clearInterval(scrollInterval)
      }else{
        currentPosition = element.scrollTop
        let newPosition = currentPosition+1
        // console.log("Scroll Top : ",newPosition+140)
        // console.log("Scroll Height : ",element.scrollHeight)
        if(isScrolling){
          element.scrollTo(0,newPosition)
        }
      }
    },120)
  
  }
  
  onTouchStart =()=>{
    console.log("TOUCH STARTED...")
    this.touchHoldTimer = setTimeout(()=>{
      this.setState({ isScrolling : false })
    },500)
  }
  
  onTouchEnd =()=>{
    console.log("TOUCH END...")
    if(this.touchHoldTimer){
      clearTimeout(this.touchHoldTimer)
    }
    this.setState({ isScrolling : true })
  }
  
  isRecodingStartedForNewDec =()=>{
    const { recordingStarted ,isNewDeclaration} = this.state
    return recordingStarted&&isNewDeclaration==='Y'
  }
  
    

    render() {
        const {
            recordingStarted,
            recordingStop,
            volCounting,
            submitFailed,
            showRecording,
            recordingTime,
            showInstructions,
            consentSubmitted,
            displayError,
            timeTaken,
            retryErr,
            retryMsg,
            fileSize,
            streamingErr,
            enableStartBtn,
            loadingCamera,
            streamErrMsg,
            selectLang,
            selectedLang,
            apiTimeoutErr,
            consentDeclarationText,
            audioError,
            submitting,
            mergeErr,
            mergeErrMsg,
            tokenGenerated,
            tokenErr,
            loading,
            thumbnailImg,
            muteAudioRecorded,
            retryMutedRecording
        } = this.state;
        const { t } = this.props;
        return (
            <>
                <audio className="aud-el-hide" id="ci-aud"></audio>
                {loading && <DotsLoader msg={this.props.t("submitting_video_text")} />}
                {selectLang &&
                    (isNewUI() ? (
                        <VideoConsentLanguageSelection
                            handleLanguageSelection={this.handleLanguageSelection}
                        />
                    ) : (
                        <ConsentLanguage
                            handleLanguageSelection={this.handleLanguageSelection}
                        />
                    ))}
                {showInstructions &&
                    (isNewUI() ? (
                        <VideoConsentInstructions
                            declarationText={consentDeclarationText}
                            hideConsentInstructions={this.hideConsentInstructions}
                        />
                    ) : (
                        <ConsentInstruction
                            hideConsentInstructions={this.hideConsentInstructions}
                        />
                    ))}
                {consentSubmitted &&
                    (isNewUI() ? (
                        <VideoSubmission
                            messageTxt={this.props.t("Video_Submitted")}
                            redirectionMsg={"otp"}
                            redirectToPage={this.redirectToPage}
                        />
                    ) : (
                        <ConsentStepperContainer
                            handleContinueBtn={this.handleContinueBtn}
                            timeTaken={timeTaken}
                            fileSize={fileSize}
                        />
                    ))}
                {isNewUI() ? (
                    <>
                        <div className={this.isRecodingStartedForNewDec()?"new-ui text-container startrecord-ui":"new-ui text-container"}>
                            <div className="textBox">
                                {/* <h3>{t('read_below')}</h3> */}
                                <p className="read-below-text">
                                    {t("Record_statement_in_your_voice")}
                                </p>
                                <p 
                                  className={
                                    this.getDeclarationTextClass()
                                  }
                                  id="scrollable-consent-text"
                                  onTouchEnd={this.onTouchEnd}
                                  onTouchStart={this.onTouchStart}
                                  onContextMenu={(e)=>{ e.preventDefault() }}
                                >
                                    {consentDeclarationText}
                                </p>
                            </div>
                        </div>

                        {recordingStop && (
                            <div className={`new-ui player-cntnr ${ muteAudioRecorded && retryMutedRecording < 2 ? 'mute-audio-err-ui' : '' }`}>
                                <h3>{muteAudioRecorded && retryMutedRecording < 2 ? this.props.t("record_again_txt_msg") : this.props.t("Looks good")}</h3>
                                <p>{muteAudioRecorded && retryMutedRecording < 2 ? this.props.t("improper_video_msg") : this.props.t("review_video_and_confirm")}</p>
                                <video
                                    id="video-player"
                                    width="252"
                                    height="294"
                                    style={{
                                        width: "290",
                                        height: "294",
                                        // visibility: `${showRecording ? "visible" : "hidden"}`,
                                    }}
                                    src={this.videoParts}
                                    playsInline
                                    poster={thumbnailImg}
                                    controls
                                ></video>
                                {recordingStop && !showRecording && (
                                    <div
                                        onClick={this.playRecording}
                                        className="play-recording-btn"
                                    >
                                        <img className="video-thumb-img" src={thumbnailImg} />
                                        <img
                                            className="play-rec-btn"
                                            src={playBtnIcon}
                                            alt="play_icon"
                                        />
                                        <p className="preview-badge-text" >{this.props.t("Preview")}</p>
                                    </div>
                                )}

                                <div className="recording-btns">
                                    <div className="all-btns">
                                        {retryErr && !apiTimeoutErr && (
                                            <small
                                                style={{ color: "red" }}
                                                className="recording-time"
                                            >
                                                {retryMsg}
                                            </small>
                                        )}
                                        {apiTimeoutErr && (
                                            <small
                                                style={{ color: "red" }}
                                                className="recording-time"
                                            >
                                                Internet Seems to be slow, Please try again later.
                                            </small>
                                        )}
                                        {mergeErr && (
                                            <small
                                                style={{ color: "red" }}
                                                className="recording-time"
                                            >
                                                {mergeErrMsg}
                                            </small>
                                        )}
                                        {tokenErr && (
                                            <small
                                                style={{ color: "red" }}
                                                className="recording-time"
                                            >
                                                Error while generating token !, try after some time
                                            </small>
                                        )}
                                        {!recordingStarted && !selectLang && (
                                            <img
                                                onClick={this.startRecording}
                                                className={
                                                    enableStartBtn ? "opacity-full" : "opacity-half"
                                                }
                                                src={recordBtnIcon}
                                                alt="start_record"
                                            />
                                        )}
                                        {recordingStop && (
                                            <img
                                                className="retake-btn-icn"
                                                onClick={this.recordAgain}
                                                src={crossBtnIcon}
                                                alt="record_again"
                                            />
                                        )}
                                        {recordingStop && this.state.recordingTime>9 && (
                                            <img
                                                className="submit-consent-icn"
                                                onClick={this.submitVideoConsent}
                                                src={checkBtnIcon}
                                                alt="submit_consent"
                                            />
                                        )}
                                        {recordingStop && (
                                            <img
                                                className="retry-btn-icn"
                                                onClick={this.recordAgain}
                                                src={recordVideoAgainIcon}
                                                alt="record_again"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className={this.isRecodingStartedForNewDec()?'new-ui video-cntnr startrecord-ui':"new-ui video-cntnr"}>
                        { this.isRecodingStartedForNewDec()&&<div className="ovrly-blurred-bg"></div>}
                            <div className="video-booth">
                                {loadingCamera && (
                                    <div className="loading-camera-cntnr">
                                        <p>{this.props.t("Starting Video")}</p>
                                    </div>
                                )}
                                {streamingErr && (
                                    <div className="streaming-err-cntnr">
                                        <p>{streamErrMsg}</p>
                                    </div>
                                )}
                                <img
                                    className="consent-record-frame"
                                    src={consentRecordFrame}
                                    alt="frame"
                                />
                                <video
                                    id="video-consent"
                                    width="240"
                                    height="240"
                                    style={{ width: "240", height: "240" }}
                                    preload={"auto"}
                                    autoPlay
                                    loop
                                    muted
                                ></video>
                            </div>
                            {volCounting > 4 && !isNewUI() ? (
                                <p
                                    className={`audio-error ${selectedLang == "manipuri" ? "manipuri-font" : ""
                                        }`}
                                >
                                    {audioError}
                                </p>
                            ) : (
                                ""
                            )}

                            <div className="recording-btns">
                                {!recordingStarted && displayError ? (
                                    <div className="audio-err-cntnr">
                                        <p
                                            className={`display-err ${selectedLang == "manipuri" ? "manipuri-font" : ""
                                                }`}
                                        >
                                            {displayError}
                                        </p>
                                        <img src={polygonIcon} alt="ploygon" />
                                        <div className="hand-animation-wrapper">
                                            <div id="hand-animaton-el"></div>
                                        </div>
                                    </div>
                                ) : null}

                                {volCounting > 4 ? (
                                    <div className="audio-err-cntnr not-speaking-err">
                                        <p
                                            className={`display-err ${selectedLang == "manipuri" ? "manipuri-font" : ""
                                                }`}
                                        >
                                            {audioError}
                                        </p>
                                        <img src={polygonIcon} alt="ploygon" />
                                        <div className="hand-animation-wrapper">
                                            <div id="hand-animaton-el"></div>
                                        </div>
                                    </div>
                                ) : null}

                                <div className="all-btns">
                                    {retryErr && !apiTimeoutErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            {retryMsg}
                                        </small>
                                    )}
                                    {apiTimeoutErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            Internet Seems to be slow, Please try again later.
                                        </small>
                                    )}
                                    {mergeErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            {mergeErrMsg}
                                        </small>
                                    )}
                                    {tokenErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            Error while generating token !, try after some time
                                        </small>
                                    )}
                                    {!recordingStarted && !selectLang && (
                                        <img
                                            onClick={this.startRecording}
                                            className={
                                                enableStartBtn ? "opacity-full" : "opacity-half"
                                            }
                                            src={recordBtnIcon}
                                            alt="start_record"
                                        />
                                    )}

                                    {recordingStarted && !recordingStop && (
                                        <div className="recording-time-badge">
                                            <p>{this.getFormattedTime(recordingTime)}</p>
                                        </div>
                                    )}
                                    {recordingStarted && !recordingStop && (
                                        <img
                                            onClick={recordingTime < 15 ? null : this.stopRecording}
                                            className={
                                                recordingTime < 15 ? "opacity-half" : "opacity-full"
                                            }
                                            src={stopRecordIcon}
                                            alt="start_record"
                                        />
                                    )}
                                    {/* {recordingStarted && !recordingStop && this.isSpeaking ? (
                                        <img
                                            className="voice_assistant"
                                            src={voiceAssistantSvg}
                                            alt="voice_assistant"
                                        />
                                    ) : (
                                        recordingStarted &&
                                        !recordingStop && (
                                            <img
                                                className="voice_assistant"
                                                src={voiceAssistanrImg}
                                                alt="voice_assistant"
                                            />
                                        )
                                    )} */}
                                      {!recordingStarted && !selectLang && (
                                        <div className={
                                                enableStartBtn ? "opacity-full recording-text" : "opacity-half recording-text"
                                            }
                                        > {this.props.t("Starting Video")} </div>
                                    )}
                                    {recordingStarted && !recordingStop && (
                                        <div className={
                                            recordingTime < 15 ? "opacity-half recording-text" : "opacity-full recording-text"
                                        } > {this.props.t("Finish Recording")} </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="text-container">
                            <div className="textBox">
                                <h3>{t("read_below")}</h3>
                                <p
                                    className={selectedLang == "manipuri" ? "manipuri-font" : ""}
                                >
                                    {consentDeclarationText}
                                </p>
                            </div>
                        </div>
                        <div className="video-cntnr">
                            <div className="video-booth">
                                {loadingCamera && (
                                    <div className="loading-camera-cntnr">
                                        <p>{this.props.t("Starting Video")}</p>
                                    </div>
                                )}
                                {streamingErr && (
                                    <div className="streaming-err-cntnr">
                                        <p>{streamErrMsg}</p>
                                    </div>
                                )}
                                <video
                                    id="video-consent"
                                    width="240"
                                    height="240"
                                    style={{ width: "240", height: "240" }}
                                    preload={"auto"}
                                    autoPlay
                                    loop
                                    muted
                                ></video>
                                <video
                                    id="video-player"
                                    width="240"
                                    height="240"
                                    style={{
                                        width: "240",
                                        height: "240",
                                        visibility: `${showRecording ? "visible" : "hidden"}`,
                                    }}
                                    src={this.videoParts}
                                    controls={false}
                                    playsInline
                                ></video>
                                <canvas
                                    id="canvas-consent"
                                    width="240"
                                    height="240"
                                    style={{
                                        visibility: `${!recordingStop ? "visible" : "hidden"}`,
                                    }}
                                ></canvas>
                                {recordingStop && !showRecording && (
                                    <div
                                        onClick={this.playRecording}
                                        className="play-recording-btn"
                                    >
                                        <img
                                            src={videoPlayerIcon}
                                            height="70px"
                                            width="90px"
                                            alt=""
                                        />
                                        <p>Recording complete</p>
                                        <img
                                            className="play-icon"
                                            src={playIcon}
                                            height="70px"
                                            width="70px"
                                            alt=""
                                        />
                                    </div>
                                )}
                            </div>
                            {volCounting > 4 ? (
                                <p
                                    className={`audio-error ${selectedLang == "manipuri" ? "manipuri-font" : ""
                                        }`}
                                >
                                    {audioError}
                                </p>
                            ) : (
                                ""
                            )}
                            {/* <MicroPhoneAccess recordAgain={this.recordAgain} /> */}
                            {recordingStarted && !recordingStop && (
                                <div className="recording-time">
                                    {/* {!this.isSpeaking && !audioError && <p> {audioError}</p>} */}
                                    <p>{this.getFormattedTime(recordingTime)}</p>
                                </div>
                            )}

                            <div className="recording-btns">
                                <div className="all-btns">
                                    {retryErr && !apiTimeoutErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            {retryMsg}
                                        </small>
                                    )}
                                    {apiTimeoutErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            Internet Seems to be slow, Please try again later.
                                        </small>
                                    )}
                                    {mergeErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            {mergeErrMsg}
                                        </small>
                                    )}
                                    {tokenErr && (
                                        <small style={{ color: "red" }} className="recording-time">
                                            Error while generating token !, try after some time
                                        </small>
                                    )}
                                    {!recordingStarted && !selectLang && (
                                        <button
                                            onClick={this.startRecording}
                                            disabled={!enableStartBtn}
                                        >
                                            {this.props.t("Start Recording")}
                                        </button>
                                    )}

                                    {recordingStarted && !recordingStop && (
                                        <button
                                            onClick={this.stopRecording}
                                            disabled={recordingTime < 10}
                                        >
                                            {this.props.t("Stop Recording")}
                                        </button>
                                    )}
                                    {recordingStop && (
                                        <button
                                            className="retake-video-btn"
                                            onClick={this.recordAgain}
                                            disabled={submitting}
                                        >
                                            {this.props.t("Record Again")}
                                        </button>
                                    )}
                                    {recordingStop && this.state.recordingTime>9 && (
                                        <button
                                            onClick={this.submitVideoConsent}
                                            disabled={submitting || !tokenGenerated || submitFailed}
                                        >
                                            {this.props.t("Submit")}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}

export default compose(
    withRouter,
    connect(null, { showLoader }),
    withTranslation()
)(VideoConsent);

VideoConsent.contextType = SpeakerContext;
